import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TeamSessionsSection from "./TeamSessionsSection";
import TeamActivitySection from "./TeamActivitySection";

/**
 * Sessions and Recent Activity in one card, one at a time. Both lists render
 * at their natural height (no internal cap) — the pane around them scrolls.
 * Both sections stay mounted so switching back is instant and nothing
 * refetches.
 */
const TeamFeedCard = ({ player = null }) => {
  const { t } = useTranslation();
  const [tab, setTab] = useState("sessions");
  const firstName = player?.name?.split(" ")[0];
  // With an athlete selected, Sessions lists their sessions; Activity stays
  // team-wide, and its label says so (SPO-1537).
  const tabs = [
    {
      key: "sessions",
      label: player
        ? t("team.sessionsSection.playerTitle", { name: firstName })
        : t("team.feedCard.sessions"),
    },
    {
      key: "activity",
      label: player
        ? t("team.feedCard.teamActivity")
        : t("team.feedCard.activity"),
    },
  ];

  return (
    <div className="rounded-xl border border-[#F3F4F6] bg-white">
      <div className="px-4 pt-4">
        <div className="flex items-center gap-1 rounded-lg bg-[#F3F4F6] p-0.5">
          {tabs.map((item) => (
            <button
              key={item.key}
              onClick={() => setTab(item.key)}
              className={`flex-1 rounded-md px-3 py-1.5 text-xs font-medium transition duration-150 ${
                tab === item.key
                  ? "bg-white text-[#111827] shadow-sm"
                  : "text-[#6B7280] hover:text-[#374151]"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
      <div hidden={tab !== "sessions"}>
        <TeamSessionsSection embedded player={player} />
      </div>
      <div hidden={tab !== "activity"}>
        <TeamActivitySection embedded />
      </div>
    </div>
  );
};

export default TeamFeedCard;
